export const url = '/app-settings';
